import useSWR from 'swr';
import { fetcher } from '@shared/fetcher';
import { StoreSchema, IStore } from '@shared/types.ts';
import { PharmacyCardProps } from '@ui/checkout/pharmacy-card';

async function fetchStores(url: string) {
  const res = await fetcher.get<{ data: IStore[] }>(url).catch(() => null);
  if (!res) return undefined;
  return res.data?.data.filter((i) => StoreSchema.isValidSync(i));
}

export function useStoresList({
  query,
  selectedCityId,
  selectedProductId,
}: {
  query?: string;
  selectedCityId?: number;
  selectedProductId?: number[];
}) {
  const cityId = selectedCityId ? `city_id=${selectedCityId}` : '';
  const product_ids = selectedProductId
    ? selectedProductId.reduce((acc, value, index) => {
        return acc + `product_ids[${index}]=${value}&`;
      }, '&')
    : '';

  const { data } = useSWR(
    `/api/pharmacies?${cityId}${product_ids}`,
    fetchStores
  );

  const mapped = data
    ?.map<PharmacyCardProps | undefined>((storeItem) => {
      return {
        name: `Zerde №${storeItem.id}`,
        address: storeItem.address,
        isLoading: false,
        statuses: [{ variant: 'open' }],
      };
    })
    .filter((item) => {
      if (!query) return true;
      if (!item) return false;
      return (
        `${item.name} ${item.address}`
          .toLowerCase()
          .search(query.toLowerCase()) > -1
      );
    });

  const array = Array(10)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: mapped || array,
    rawData: data,
  };
}
